import bungalowInterior1 from "../../assets/aurangabad-house/warm-living-01.jpeg";
import bungalowInterior2 from "../../assets/aurangabad-house/warm-kitchen-01-ai.png";
import bungalowInterior3 from "../../assets/aurangabad-house/warm-bedroom-01-ai.png";
import bungalowInterior4 from "../../assets/aurangabad-house/warm-dining-01-ai.png";
import heroSection from "../../assets/aurangabad-house/warm-bedroom-06-ai.png"
import familyFocus from "../../assets/aurangabad-house/warm-bedroom-03-ai.png"
import bigImage from "../../assets/aurangabad-house/warm-living-tv-unit1.png"

const BunglowInterior = {
    title: "Bunglow Interior",
    category: "Residential / 4BHK Bunglow",
    facts: [
      { label: "Location", value: "Vaijapur" },
      { label: "Year", value: "2026" },
      { label: "Area", value: "2500 sq ft" },
      { label: "Category", value: "Residential" },
      { label: "Services", value: "Full Interior Design" },
    ],
    heroImage: heroSection,
    heroAlt: "Bunglow Interior in Vaijapur",
    overview:
      "A comprehensive interior design project for a 4BHK bunglow in Vaijapur. The design creates a warm, inviting living environment with careful attention to functionality, comfort, and aesthetic appeal throughout all spaces.",
    fullbleedImage: bigImage,
    fullbleedAlt: "Bunglow Interior kitchen design",
    fullbleedQuote: "Thoughtful interior design transforms a bunglow into a comfortable family home.",
    // chapters: [
    //   {
    //     eyebrow: "01 - Living Spaces",
    //     title: "Family-Focused Design",
    //     body: "The living areas are designed to be welcoming and functional, with comfortable seating, good lighting, and a layout that encourages family gathering and entertaining.",
    //     image: familyFocus,
    //     alt: "Bunglow Interior living area",
    //   },
    //   {
    //     eyebrow: "02 - Kitchen & Dining",
    //     title: "Modern Culinary Space",
    //     body: "The kitchen features modern appliances, efficient workflow, and style, while the dining area is designed for comfortable family meals and entertaining guests.",
    //     image: bungalowInterior2,
    //     alt: "Bunglow Interior kitchen",
    //   },
    //   {
    //     eyebrow: "03 - Bedrooms",
    //     title: "Comfortable Retreats",
    //     body: "Each bedroom is designed with comfort and functionality in mind, featuring coordinated furnishings, proper lighting, and adequate storage solutions.",
    //     image: bungalowInterior3,
    //     alt: "Bunglow Interior bedroom",
    //   },
    //   {
    //     eyebrow: "04 - Finishing Touches",
    //     title: "Cohesive Design Language",
    //     body: "Color schemes, materials, and finishes are carefully selected to create a unified, inviting aesthetic that flows naturally throughout the entire bunglow.",
    //     image: bungalowInterior4,
    //     alt: "Bunglow Interior dining area",
    //   },
    // ],
    
    chapters: [
  {
    eyebrow: "01 - BEDROOM",
    title: "A Playful Space for Growing Up",
    body: "A smart bunk-bed setup combines sleep, storage and a warm wooden finish to make the room both practical and inviting.",
    image: familyFocus,
    alt: "Bungalow Interior bedroom with custom bunk bed",
  },
  {
    eyebrow: "02 - KITCHEN",
    title: "Clean, Modern & Functional",
    body: "A sleek modular kitchen brings together practical storage, clean finishes and warm lighting for effortless everyday living.",
    image: bungalowInterior2,
    alt: "Bungalow Interior modern modular kitchen",
  },
  {
    eyebrow: "03 - MASTER BEDROOM",
    title: "Warmth in Every Detail",
    body: "Soft tones, natural wood and integrated lighting create a calm bedroom designed for comfort and unwinding.",
    image: bungalowInterior3,
    alt: "Bungalow Interior master bedroom",
  },
  {
    eyebrow: "04 - DINING",
    title: "Designed to Gather Around",
    body: "A refined dining space pairs elegant cabinetry, warm textures and thoughtful lighting to make everyday meals feel special.",
    image: bungalowInterior4,
    alt: "Bungalow Interior dining area with modern cabinetry",
  },
],
    
    gallery: [
       {
        image: bungalowInterior3,
        alt: "Bunglow Interior warm master bedroom",
        caption: "Master bedroom with warm wood and soft lighting",
      },
      
      {
        image: bungalowInterior1,
        alt: "Bunglow Interior living room with TV unit",
        caption: "Living room with composed TV wall and seating",
      },
      {
        image: bungalowInterior2,
        alt: "Bunglow Interior modern modular kitchen",
        caption: "Modular kitchen with efficient storage and workflow",
      },
    
      {
        image: bungalowInterior4,
        alt: "Bunglow Interior dining space with cabinetry",
        caption: "Dining area with elegant cabinetry and warm finishes",
      },
    ],
  };

export default BunglowInterior;
